import React, { useEffect, useState } from "react";
import { postJsonData } from "../network/ApiController";
import ApiEndpoints from "../network/ApiEndPoints";
import { apiErrorToast, apiSuccessToast } from "../utils/ToastUtil";
import {
  FormControl,
  Grid,
  TextField,
  Typography,
  Button,
  Box,
  Select,
  MenuItem,
  CircularProgress,
} from "@mui/material";

const PartPaymentElectricity = () => {
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState([]);
  const [billerName, setBillerName] = useState("");
  const [formData, setFormData] = useState({});

  const getBillersDetails = () => {
    setLoading(true);

    postJsonData(
      ApiEndpoints.BBPS_GET_BILLERS_DETAILS,
      { billerId: "TATAPWR00DEL01" },
      setLoading,
      (res) => {
        const data = res.data?.data || {};
        let updatedParams = data.parameters || [];

        if (!updatedParams.some((param) => param.desc === "Mobile Number")) {
          updatedParams.push({
            name: "mobileNumber",
            desc: "Mobile Number",
            minLength: 10,
            maxLength: 10,
            inputType: "NUMERIC",
            mandatory: 1,
            regex: "^[6-9]\d{9}$",
          });
        }

        if (!updatedParams.some((param) => param.name === "amount")) {
          updatedParams.push({
            name: "amount",
            desc: "Amount",
            minLength: 2,
            maxLength: 7,
            inputType: "NUMERIC",
            mandatory: 1,
            regex: "^[0-9]+$",
          });
        }

        setParams(updatedParams);
        setBillerName(data.billerInfo?.name || "");
        setLoading(false);
      },
      (err) => {
        apiErrorToast(err);
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getBillersDetails();
  }, []);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData({ ...formData, [id]: value });
  };

  return (
    <Box
      sx={{
        p: 4,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#F7F4EF",
      }}
    >
      <Box
        sx={{
          p: 4,
          width: "100%",
          maxWidth: 500,
          borderRadius: "16px",
          bgcolor: "white",
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Typography
          variant="h4"
          align="center"
          sx={{ fontWeight: "bold", color: "#D48628", mb: 2 }}
        >
          Electricity Payment
        </Typography>

        {loading ? (
          <Box display="flex" justifyContent="center" my={2}>
            <CircularProgress sx={{ color: "#D48628" }} />
          </Box>
        ) : (
          <>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <Select value={billerName} displayEmpty>
                <MenuItem value="" disabled>
                  Select Provider
                </MenuItem>
                <MenuItem value={billerName}>{billerName}</MenuItem>
              </Select>
            </FormControl>

            <Grid container spacing={2}>
              {params.map((item, index) => (
                <Grid item xs={12} key={index}>
                  <TextField
                    label={item.desc}
                    id={item.name}
                    inputProps={{
                      minLength: item.minLength,
                      maxLength: item.maxLength,
                      pattern: item.regex,
                    }}
                    size="small"
                    required={item.mandatory === 1}
                    type={item.inputType === "NUMERIC" ? "number" : "text"}
                    value={formData[item.name] || ""}
                    onChange={handleChange}
                    fullWidth
                  />
                </Grid>
              ))}

              <Grid item xs={12}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    bgcolor: "#D48628",
                    color: "#fff",
                    borderRadius: "8px",
                    fontSize: "1rem",
                    textTransform: "none",
                    "&:hover": { bgcolor: "#B36A22" },
                  }}
                >
                  Proceed to Pay
                </Button>
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PartPaymentElectricity;